import { IsEqualToRule } from "./Validation/IsEqualToRule";
import { Validator, IValidationOptions } from "./Validation/Validator";

export class Core
{
    public validationOptions: IValidationOptions = {
        invalidFieldLabel: '',
        isRequiredLabel: '',
        mustBeNumberLabel: '',
        mustBeEqualToLabel: '',
        mustBeGreaterThanLabel: '',
        mustBeMaxLengthLabel: '',
        mustBeValidEmailLabel: '',
    };

    public configureValidation(options: IValidationOptions): Core
    {
        this.validationOptions.invalidFieldLabel = options.invalidFieldLabel;
        this.validationOptions.isRequiredLabel = options.isRequiredLabel;
        this.validationOptions.mustBeNumberLabel = options.mustBeNumberLabel;
        this.validationOptions.mustBeEqualToLabel = options.mustBeEqualToLabel;
        this.validationOptions.mustBeGreaterThanLabel = options.mustBeGreaterThanLabel;
        this.validationOptions.mustBeMaxLengthLabel = options.mustBeMaxLengthLabel;
        this.validationOptions.mustBeValidEmailLabel = options.mustBeValidEmailLabel;
        return this;
    }
}
